import { memo } from 'react';
import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, Autocomplete, Typography, MenuItem } from '@mui/material';



// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
};

 function RHFTextField({ name, options, ...other }) {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          freeSolo
          options={options && options}
          onSelect={e => { setValue(name, e.target.value) }}
          renderInput={(params) => <TextField
            {...params}
            {...field}
            fullWidth
            error={!!error}
            helperText={error?.message}
            {...other}
          />}
        />

        // <TextField
        //   {...field}
        //   fullWidth
        //   value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
        //   error={!!error}
        //   helperText={error?.message}
        //   {...other}
        // />
      )}
    />
  );
}

export default memo(RHFTextField)
